import createField from './createField';
import plain from './structure/plain';

export default createField(plain);


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/es/Field.js
// module id = 1899
// module chunks = 1